import {
  AnchorButton,
  Button,
  ControlGroup,
  InputGroup,
  NumericInput,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { compareTwoObjects, niceDate } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { nanoid } from "nanoid";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import { DateInput } from "@blueprintjs/datetime";

class SxSurgeonSchedules extends React.Component {
  state = {
    changed: false,
    site: null,
    surgeonId: null,
    surgeonName: null,
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
    validFrom: null,
    validTo: null,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  hhList = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];
  mmList = ["00", "15", "30", "45"];
  renderWeekdaySchedule = (day) => {
    let list = this.state[day];

    return (
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <ControlGroup>
          <Tag large minimal style={{ width: "100px" }}>
            {_.startCase(day)}
          </Tag>
          <Button
            icon="add"
            onClick={() => {
              let newObj = {
                begin: { HH: "", MM: "" },
                end: { HH: "", MM: "" },
                beginHHMM: 0,
                endHHMM: 0,
                maximum: 0,
                nanoid: nanoid(),
                slotName: "",
              };
              this.setState({ [day]: [...list, newObj] }, () => {
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                );
              });
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {list.map((each, indx) => {
              return (
                <ControlGroup style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <ControlGroup>
                    <Tag
                      intent="primary"
                      large
                      minimal
                      onRemove={() => {
                        this.setState(
                          {
                            [day]: list.filter(
                              (each1) => each1.nanoid !== each.nanoid
                            ),
                          },
                          () => {
                            this.props.onUpdate(
                              compareTwoObjects(this.state, this.props.data)
                            );
                          }
                        );
                      }}
                    >
                      Slot {indx + 1}
                    </Tag>
                    <InputGroup
                      // large
                      minimal
                      placeholder="Slot Name"
                      value={each.slotName}
                      onChange={(event) => {
                        let newList = [...list];
                        newList[indx].slotName = event.target.value;
                        this.setState({ [day]: newList });
                      }}
                    />
                    <NumericInput
                      style={{ width: "7em" }}
                      value={each.maximum}
                      buttonPosition="NONE"
                      rightElement={<Tag minimal>Max</Tag>}
                      onValueChange={(number) => {
                        let newList = [...list];
                        newList[indx].maximum = number;

                        this.setState(
                          {
                            [day]: newList,
                          },
                          () =>
                            this.props.onUpdate(
                              compareTwoObjects(this.state, this.props.data)
                            )
                        );
                      }}
                    />
                  </ControlGroup>
                  <ControlGroup>
                    <SingleSelectWrapper
                      width="40px"
                      placeholder="HH"
                      items={this.hhList}
                      selectedItem={each.begin.HH}
                      onChange={(item) => {
                        let newList = [...list];
                        newList[indx].begin.HH = item;
                        this.setState({ [day]: newList }, () => {
                          this.props.onUpdate(
                            compareTwoObjects(this.state, this.props.data)
                          );
                        });
                      }}
                    />
                    <SingleSelectWrapper
                      width="40px"
                      placeholder="MM"
                      items={this.mmList}
                      selectedItem={each.begin.MM}
                      onChange={(item) => {
                        let newList = [...list];
                        newList[indx].begin.MM = item;
                        console.log("newList", newList, indx, item);
                        this.setState({ [day]: newList }, () => {
                          this.props.onUpdate(
                            compareTwoObjects(this.state, this.props.data)
                          );
                        });
                      }}
                    />{" "}
                    <Tag minimal intent="success" icon="arrow-right"></Tag>
                    <SingleSelectWrapper
                      width="40px"
                      placeholder="HH"
                      items={this.hhList}
                      selectedItem={each.end.HH}
                      onChange={(item) => {
                        let newList = [...list];
                        newList[indx].end.HH = item;
                        this.setState({ [day]: newList }, () => {
                          this.props.onUpdate(
                            compareTwoObjects(this.state, this.props.data)
                          );
                        });
                      }}
                    />{" "}
                    <SingleSelectWrapper
                      width="40px"
                      placeholder="MM"
                      items={this.mmList}
                      selectedItem={each.end.MM}
                      onChange={(item) => {
                        let newList = [...list];
                        newList[indx].end.MM = item;
                        console.log("newList", newList, indx, item);
                        this.setState({ [day]: newList }, () => {
                          this.props.onUpdate(
                            compareTwoObjects(this.state, this.props.data)
                          );
                        });
                      }}
                    />{" "}
                  </ControlGroup>
                </ControlGroup>
              );
            })}
          </div>
        </ControlGroup>
      </div>
    );
  };

  render() {
    return (
      <>
        {/* <td>
          {this.state.surgeonId ? (
            <ControlGroup vertical>
              <Tag intent="primary" large multiline>
                {this.state.surgeonName}
              </Tag>
              <Button
                icon="edit"
                onClick={() =>
                  this.setState({ surgeonId: null, surgeonName: null }, () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                  )
                }
              />
            </ControlGroup>
          ) : (
            <SingleIDSelectWrapper
              showSelectProp={true}
              width="200px"
              items={this.props.docs.map((each) => {
                return {
                  ...each,
                  searchName: `${each.shortcode || ""} | ${each.name}`,
                };
              })}
              selectedItem={this.state.selectedSurgeon}
              labelKey="searchName"
              onChange={(item) => {
                this.setState(
                  {
                    surgeonId: item._id,
                    surgeonName: item.name,
                    selectedSurgeon: item,
                    changed: true,
                  },
                  () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                );
              }}
            />
          )}
        </td>
        <td>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <ControlGroup vertical style={{ marginBottom: "10px" }}>
              <ControlGroup>
                <Tag large minimal>
                  Site
                </Tag>
              </ControlGroup>
              <SingleSelectWrapper
                items={this.props.sites}
                selectedItem={this.state.site}
                onChange={(item) =>
                  this.setState({ site: item, changed: true }, () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                  )
                }
              />
            </ControlGroup>
            <ControlGroup vertical style={{ marginBottom: "10px" }}>
              <ControlGroup>
                <Tag large minimal>
                  From:
                </Tag>
              </ControlGroup>
              {this.state.validFrom ? (
                <ControlGroup>
                  <Tag
                    intent="primary"
                    minimal
                    large
                    onRemove={() =>
                      this.setState({ validFrom: null }, () =>
                        this.props.onUpdate(
                          compareTwoObjects(this.state, this.props.data)
                        )
                      )
                    }
                  >
                    {niceDate(this.state.validFrom)}
                  </Tag>
                </ControlGroup>
              ) : (
                <DateInput
                  minDate={new Date("1900")}
                  value={this.state.validFrom || null}
                  formatDate={(date) => niceDate(date)}
                  parseDate={(str) => new Date(str)}
                  onChange={(value) =>
                    this.setState({ validFrom: value }, () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                    )
                  }
                  maxDate={new Date("2100")}
                  placeholder="From"
                />
              )}
            </ControlGroup>
            <ControlGroup vertical>
              <ControlGroup>
                <Tag large minimal>
                  To
                </Tag>
              </ControlGroup>
              {this.state.validTo ? (
                <ControlGroup>
                  <Tag
                    intent="primary"
                    minimal
                    large
                    onRemove={() =>
                      this.setState({ validTo: null }, () =>
                        this.props.onUpdate(
                          compareTwoObjects(this.state, this.props.data)
                        )
                      )
                    }
                  >
                    {niceDate(this.state.validTo)}
                  </Tag>
                </ControlGroup>
              ) : (
                <DateInput
                  minDate={new Date("1900")}
                  value={this.state.validTo || null}
                  formatDate={(date) => niceDate(date)}
                  parseDate={(str) => new Date(str)}
                  onChange={(value) =>
                    this.setState({ validTo: value }, () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                    )
                  }
                  maxDate={new Date("2100")}
                  placeholder="To"
                />
              )}
            </ControlGroup>
          </div>
        </td> */}
        <td>
          <div style={{ display: "flex" }}>
            <Tag large style={{ marginBottom: "20px", marginRight: "5px" }}>
              {this.props.data.surgeonName}
            </Tag>
            {/* <Tag large style={{ marginBottom: "20px", marginRight: "5px" }}>
            {niceDate(this.props.data.validFrom)} -{" "}
            {niceDate(this.props.data.validTo)}
          </Tag> */}
            {/* <DateRangeInput
            value={[
              moment().startOf("day").toDate(this.state.validFrom),
              moment().startOf("day").toDate(this.state.validTo),
            ]}
            formatDate={(date) => niceDate(date)}
            parseDate={(str) => new Date(str)}
            minDate={new Date(2021, 0, 1)}
            maxDate={new Date(2030, 0, 1)}
            allowSingleDayRange
            contiguousCalendarMonths={false}
            onChange={(value) => {
              this.setState(
                {
                  validFrom: value[0],
                  validTo: value[1],
                },
                () => {
                  console.log("this.state", this.state.validFrom);
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  );
                }
              );
            }}
          /> */}
            {/* <ControlGroup> */}
            <ControlGroup
              large
              style={{ marginBottom: "20px", marginRight: "5px" }}
            >
              <ControlGroup>
                <Tag large>From:</Tag>
              </ControlGroup>
              {this.state.validFrom ? (
                <ControlGroup>
                  <Tag
                    intent="primary"
                    minimal
                    large
                    onRemove={() =>
                      this.setState({ validFrom: null }, () =>
                        this.props.onUpdate(
                          compareTwoObjects(this.state, this.props.data)
                        )
                      )
                    }
                  >
                    {niceDate(this.state.validFrom)}
                  </Tag>
                </ControlGroup>
              ) : (
                <DateInput
                  minDate={new Date("1900")}
                  value={this.state.validFrom || null}
                  formatDate={(date) => niceDate(date)}
                  parseDate={(str) => new Date(str)}
                  onChange={(value) =>
                    this.setState({ validFrom: value }, () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                    )
                  }
                  maxDate={new Date("2100")}
                  placeholder="From"
                />
              )}
            </ControlGroup>
            <ControlGroup
              large
              style={{ marginBottom: "20px", marginRight: "5px" }}
            >
              <ControlGroup>
                <Tag large>To</Tag>
              </ControlGroup>
              {this.state.validTo ? (
                <ControlGroup>
                  <Tag
                    intent="primary"
                    minimal
                    large
                    onRemove={() =>
                      this.setState({ validTo: null }, () =>
                        this.props.onUpdate(
                          compareTwoObjects(this.state, this.props.data)
                        )
                      )
                    }
                  >
                    {niceDate(this.state.validTo)}
                  </Tag>
                </ControlGroup>
              ) : (
                <DateInput
                  minDate={new Date("1900")}
                  value={this.state.validTo || null}
                  formatDate={(date) => niceDate(date)}
                  parseDate={(str) => new Date(str)}
                  onChange={(value) =>
                    this.setState({ validTo: value }, () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                    )
                  }
                  maxDate={new Date("2100")}
                  placeholder="To"
                />
              )}
            </ControlGroup>

            <Tag large style={{ marginBottom: "20px", marginRight: "5px" }}>
              {this.props.data.site}
            </Tag>

            <Tag
              icon="delete"
              large
              style={{ marginBottom: "20px", marginRight: "5px" }}
              onClick={() => {
                this.props.onDelete();
              }}
            ></Tag>
          </div>
          {this.renderWeekdaySchedule("monday")}
          {this.renderWeekdaySchedule("tuesday")}
          {this.renderWeekdaySchedule("wednesday")}
          {this.renderWeekdaySchedule("thursday")}
          {this.renderWeekdaySchedule("friday")}
          {this.renderWeekdaySchedule("saturday")}
          {this.renderWeekdaySchedule("sunday")}
        </td>
      </>
    );
  }
}

export default inject("authStore")(observer(SxSurgeonSchedules));
